import { Image } from "antd";
import { imagePlaceholder } from "../../../common";

interface Props {
  imageLink: string;
  full?: boolean;
  small?: boolean;
}

export default function WishImage({ imageLink, full, small }: Props) {
  return (
    <div
      className={
        "z-1 flex flex-col justify-center overflow-hidden rounded-3xl" +
        " " +
        (full ? "w-full" : small ? "h-24 w-24" : "h-64 w-64")
      }
    >
      <Image
        className={
          "aspect-square object-scale-down" +
          " " +
          (full ? "" : small ? "h-24 w-24" : "h-64 w-64")
        }
        src={imageLink || undefined}
        fallback={imagePlaceholder}
        preview={false}
      />
    </div>
  );
}
